module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_01@3x-b1f884314ff88feab0f55971954ec6ad.webp";